import React from 'react';
import { Helmet } from 'react-helmet';
import config from '../../../config';

const safeStringify = (obj) => JSON.stringify(obj).replace(/</g, '\\u003c');

const Meta = (data) => {
    return (
        <Helmet>
            {data.canonical && <link rel="canonical" href={data.canonical} />}
            {data.jsonLd && (
                <script type="application/ld+json">
                    {safeStringify(data.jsonLd)}
                </script>
            )}
            {data.tags?.length && data.tags.map((tag) => {
                return (
                    React.createElement(tag.name, { key: tag.name }, tag.content)
                );
            })}
            {data.metaTags?.length && data.metaTags.map((metaTag) => {
                if (!!metaTag.name && !!metaTag.property) {
                    return (
                        <React.Fragment key={`${metaTag.name}-${metaTag.property}`}>
                            <meta name={metaTag.name} content={metaTag.content} />
                            <meta property={metaTag.property} content={metaTag.content} />
                        </React.Fragment>
                    );
                }
                if (metaTag.name) {
                    return (
                        <meta name={metaTag.name} content={metaTag.content} key={metaTag.name} />
                    );
                }
                if (metaTag.property) {
                    return (
                        <meta property={metaTag.property} content={metaTag.content} key={metaTag.property} />
                    );
                }
                return null;
            })}
        </Helmet>
    );
};

const head = (data) => {
    return (
        <Meta
            canonical={data.canonical}
            jsonLd={data.jsonLd}
            tags={[
                { name: 'title', content: (data.clampedTitle || data.title || config.defaultTitle) },
            ]}
            metaTags={[
                { name: 'description', content: (data.description || 'Find tennis and pickleball events, leagues, and tournaments near you. Get your free UTR Rating and UTR Pickleball Rating (UTR-P) within minutes.') },
                { name: 'keywords', content: (data.keywords || '') },
                { property: 'og:type', content: 'website' },
                { property: 'og:title', content: (data.title || config.defaultTitle) },
                { property: 'og:description', content: (data.description || 'Find tennis and pickleball events, leagues, and tournaments near you. Get your free UTR Rating and UTR Pickleball Rating (UTR-P) within minutes.') },
                { property: 'og:image', content: (data.image || `https://www.${config.siteBaseUrl}/img/utr_sports/utr-sports-logo.svg`) },
                { property: 'og:url', content: (data.url || `https://${config.siteBaseUrl}`) },
                { property: 'og:image:width', content: (data.imageWidth || '930') },
                { property: 'og:image:height', content: (data.imageHeight || '395') },
                { name: 'twitter:card', content: 'summary' },
                { name: 'twitter:site', content: `${config.twitterAccount}` },
                { name: 'twitter:creator', content: `${config.twitterAccount}` },
                { name: 'twitter:url', content: (data.url || `https://${config.siteBaseUrl}`) },
                { name: 'twitter:title', content: (data.title || config.defaultTitle) },
                { name: 'twitter:description', content: (data.description || 'Find tennis and pickleball events, leagues, and tournaments near you. Get your free UTR Rating and UTR Pickleball Rating (UTR-P) within minutes.') },
                { name: 'twitter:image', content: (data.image || `https://www.${config.siteBaseUrl}/img/utr_sports/utr-sports-logo.svg`) },
            ]}
        />
    );
};

export default head;
